import React from 'react';
import FadeIn from './ui/FadeIn';
import Button from './ui/Button';

// Using the provided product images to showcase the designs
const images = [
  "https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvanBlZw==/a6855d59c5afd554a91772c7eeaed4c3.jpeg",
  "https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvanBlZw==/c886b37b9152a1bde6624be9a1ae8db9.jpeg",
  "https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvanBlZw==/32425da74229ec8dbd8163e5a358111c.jpeg",
  "https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/094402f46f724d21891fee07e9a0051e.png"
];

export default function DesignLibrary() {
  return (
    <section className="py-24 bg-warmWhite overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 text-center mb-16">
        <FadeIn>
          <h2 className="font-heading text-4xl font-bold mb-4">Hundreds of designs.<br/>One size. Endless occasions.</h2>
        </FadeIn>
      </div>
      
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {images.map((src, idx) => (
            <FadeIn key={idx} delay={idx * 0.1}>
              <div className="rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 h-full aspect-[4/5]">
                <img 
                  src={src} 
                  alt="Vase design example" 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" 
                />
              </div>
            </FadeIn>
          ))}
        </div>
      </div>

      <FadeIn className="text-center mt-16" delay={0.2}>
        <Button href="https://florist.smilevase.com">
          Browse All Designs
        </Button>
      </FadeIn>
    </section>
  );
}